module.exports = __webpack_public_path__ + "images/assets/6228f710657c22a798b95227c57ee231.svg";